/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The user's selected way to pay for a visit. Vendor-neutral: whether an insurance-paid visit
 * is backed by Bridge (or another vendor) is derived server-side from the eligibility check, not
 * from this selection.
 */
export type PaymentMode = (typeof PaymentMode)[keyof typeof PaymentMode];

export const PaymentMode = {
  insurance: "insurance",
  cash: "cash",
} as const;
